import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	pageHeader: {
		id: 'admin-pages-issue-types-directory.page-header',
		defaultMessage: 'Issue types',
		description: 'Page header for issue types global admin page',
	},
	pageInfo: {
		id: 'admin-pages-issue-types-directory.page-info',
		defaultMessage:
			'Issue types allow you to structure your work within your teams. You can assign these issue types to a new hierarchy level on the <b>Issue type hierarchy</b> page.',
		description: 'Page info for issue types global admin page',
	},
	pageInfoLinkSpork: {
		id: 'admin-pages-issue-types-directory.page-info-link-spork',
		defaultMessage: 'Learn more about issue types in Jira.',
		description: 'Link text to prompt users to read about issue types',
	},
	pageInfoLinkTitle: {
		id: 'admin-pages-issue-types-directory.page-info-link-title',
		defaultMessage: 'What are issue types?',
		description: 'Link title to prompt users to read about issue types',
	},
	filterPlaceholder: {
		id: 'admin-pages-issue-types-directory.filter-placeholder',
		defaultMessage: 'Filter Issue Types by name or description',
		description: 'Placeholder text of the Issue Types search filter',
	},
});
